import React from "react";
import { TransformButton } from "./CtaButton";
const readyItems = ["Cada documento.", "Cada proceso.", "Cada checklist.", "Cada protocolo.", "Cada formato."];
export function Presentation() {
  return <section className="w-full bg-neutral-900 py-14" data-id="element-121" data-mp="2eq0pqtnm5zuw">
      <div className="mx-auto max-w-lg px-4 text-center" data-id="element-122" data-mp="29rz3jzuw5kf7">
        <p className="font-display text-xs font-bold uppercase tracking-widest text-amber-400" data-id="element-123" data-mp="29rfwxfaoyigh">
          Presentamos
        </p>
        <h2 className="mt-3 font-display text-3xl font-extrabold leading-tight text-white" data-id="element-124" data-mp="25o175wwyanpu">
          🔧 Sistema Técnico <span className="text-amber-400" data-id="element-125" data-mp="1vs7sa6vrei4w">PRO 360™</span>
        </h2>
        <p className="mt-4 text-base leading-relaxed text-white/70" data-id="element-126" data-mp="1vuajgu8nehb7">
          El sistema de operación diseñado para ayudarte a convertir un oficio
          en un negocio organizado, rentable y profesional.
        </p>

        <div className="mt-6 space-y-1.5 text-sm font-semibold text-white/60" data-id="element-127" data-mp="3l74ko8vrrlic">
          <p data-id="element-128" data-mp="3l51kwx4tee0f">No es un curso.</p>
          <p data-id="element-129" data-mp="2v1azi1fburft">No es una colección de PDFs.</p>
        </div>

        <p className="mt-4 text-base leading-relaxed text-white/80" data-id="element-130" data-mp="2uzq64f4r1ejj">
          Es un{" "}
          <span className="font-bold text-white" data-id="element-131" data-mp="301p75id0nzdb">sistema completo</span> que
          reúne todo lo que normalmente tardarías meses o años en crear por tu
          cuenta.
        </p>

        <div className="mx-auto mt-6 max-w-xs space-y-1.5" data-id="element-132" data-mp="2q2q0g5btadsy">
          {readyItems.map(r => <p key={r} className="font-display text-lg font-bold text-amber-400" data-id="element-133" data-mp="3dsu2i89cq5hu">
              {r}
            </p>)}
        </div>

        <p className="mt-6 text-base font-semibold text-white" data-id="element-134" data-mp="342hj4jd9wida">
          Ya está listo. Solo debes descargarlo, personalizarlo y comenzar a
          utilizarlo.
        </p>

        <div className="mt-8 flex justify-center" data-id="element-135" data-mp="l938523vsl7">
          <TransformButton label="Quiero mi sistema completo" data-id="element-136" data-mp="jfywweytkgd" />
        </div>
      </div>
    </section>;
}